import React, { useEffect } from 'react';
import styles from '../../styles/CierreCicloEscolarStyles/CierreCicloEscolar.module.css';

function ConfirmationModal({ program, onConfirm, onCancel }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onCancel();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onCancel]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div 
      className={styles.modalOverlay} 
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirmation-modal-title"
    >
      <div className={styles.confirmationModal}>
        <div className={styles.modalHeader}>
          <h2 id="confirmation-modal-title" className={styles.modalTitle}>
            Confirmación de cierre del programa
          </h2>
          <button 
            className={styles.closeButton} 
            onClick={onCancel}
            aria-label="Cerrar modal"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div className={styles.modalContent}>
          {/* Success Alert */}
          <div className={styles.successAlert}>
            <div className={styles.successIcon}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
            </div>
            <div className={styles.successContent}>
              <div className={styles.successTitle}>No existen calificaciones pendientes</div>
              <div className={styles.successText}>
                Se procederá a realizar el cierre académico del programa.
              </div>
            </div>
          </div>

          {/* Program Details Card */}
          <div className={styles.confirmationCard}>
            <h3 className={styles.confirmationCardTitle}>Estás a punto de cerrar el ciclo para:</h3>
            
            <div className={styles.confirmationDetails}>
              <div className={styles.confirmationDetailRow}>
                <span className={styles.confirmationLabel}>Campus:</span>
                <span className={styles.confirmationValue}>{program.campus}</span>
              </div>
              
              <div className={styles.confirmationDetailRow}>
                <span className={styles.confirmationLabel}>Sección:</span>
                <span className={styles.confirmationValue}>{program.seccion}</span>
              </div>
              
              <div className={styles.confirmationDetailRow}>
                <span className={styles.confirmationLabel}>Programa:</span>
                <span className={styles.confirmationValue}>{program.nombre}</span>
              </div>
              
              <div className={styles.confirmationDetailRow}>
                <span className={styles.confirmationLabel}>Ciclo escolar:</span>
                <span className={styles.confirmationValue}>{program.cicloEscolar}</span>
              </div>
            </div>

            <div className={styles.warningSection}>
              <h4 className={styles.warningSectionTitle}>Este proceso es irreversible.</h4>
              <p className={styles.warningSectionText}>Una vez cerrado:</p>
              <ul className={styles.warningList}>
                <li>Se calcularán los promedios finales</li>
                <li>Se actualizará el avance curricular</li>
                <li>Ya no se podrán modificar calificaciones</li>
              </ul>
            </div>

            <p className={styles.confirmationQuestion}>¿Deseas continuar con el cierre de ciclo?</p>
          </div>
        </div>
        
        <div className={styles.modalFooter}>
          <button className={styles.cancelButton} onClick={onCancel}>
            CANCELAR
          </button>
          <button className={styles.confirmButton} onClick={onConfirm}>
            CONFIRMAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
